import type { PageMeta } from "@repo/dashboard-core";

// CUSTOMIZE: Map routes to page title/subtitle translation keys
export const routeMap: Record<string, PageMeta> = {
  "/": {
    titleKey: "page-meta.my-files.title",
    subtitleKey: "page-meta.my-files.subtitle",
  },
  "/ai-chat": {
    titleKey: "page-meta.ai-chat.title",
    subtitleKey: "page-meta.ai-chat.subtitle",
  },
  "/tools": {
    titleKey: "page-meta.tools.title",
    subtitleKey: "page-meta.tools.subtitle",
  },
  "/file-tools": {
    titleKey: "page-meta.file-tools.title",
    subtitleKey: "page-meta.file-tools.subtitle",
  },
  "/cv-maker": {
    titleKey: "page-meta.cv-maker.title",
    subtitleKey: "page-meta.cv-maker.subtitle",
  },
  "/forms": {
    titleKey: "page-meta.forms.title",
    subtitleKey: "page-meta.forms.subtitle",
  },
  "/document": {
    titleKey: "page-meta.document.title",
    subtitleKey: "page-meta.document.subtitle",
  },
  "/profile": {
    titleKey: "page-meta.profile.title",
    subtitleKey: "page-meta.profile.subtitle",
  },
  "/messages": {
    titleKey: "page-meta.messages.title",
    subtitleKey: "page-meta.messages.subtitle",
  },
  "/faq": {
    titleKey: "page-meta.faq.title",
    subtitleKey: "page-meta.faq.subtitle",
  },
  "/contact": {
    titleKey: "page-meta.contact.title",
    subtitleKey: "page-meta.contact.subtitle",
  },
  "/preview": {
    titleKey: "page-meta.my-files.title",
    subtitleKey: "page-meta.my-files.subtitle",
  },
  "/editor": {
    titleKey: "page-meta.editor.title",
    subtitleKey: "page-meta.editor.subtitle",
  },
};
